<template>
  <div id="app">
    <router-view></router-view>
    <re-login-dialog></re-login-dialog>
  </div>
</template>

<script>

  import ReLoginDialog from '@/views/login/ReLoginDialog'

  export default {
    name: 'app',
    components: { ReLoginDialog }
  }
</script>

<style>
  #app {
    font-family: 微软雅黑,新宋体, Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
